import { GET } from "../../../API/get";
import { PUT } from "../../../API/put";

export const fetchJobDetails = async (re_call_visit_id) => {
    const response = await GET(`re-call/visit/${re_call_visit_id}`);
    if (response.status !== "Success") {
        throw new Error('Failed to update re-call visit status');
    }
    return response;
}

export const updateReCallVisitStatus = async (re_call_visit_id, status) => {
    const response = await PUT(`re-call/visit/approval/customer`,{
        re_call_visit_id: re_call_visit_id,
        approval_status: status
    });
    if (response.status !== "Success") {
        throw new Error('Failed to update re-call visit status');
    }
    return response;
}